export default "__VITE_PUBLIC_ASSET__dbfe5530__"